var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Paint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7413",
    "data-name": "Rectangle 7413",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11057",
    "data-name": "Path 11057",
    d: "M12,2c5.522,0,10,3.978,10,8.889a5.558,5.558,0,0,1-5.556,5.556H14.478a1.66,1.66,0,0,0-1.245,2.767A1.667,1.667,0,0,1,12,22,10,10,0,0,1,12,2ZM10.811,18.111a3.664,3.664,0,0,1,3.667-3.667h1.967A3.558,3.558,0,0,0,20,10.889C20,7.139,16.468,4,12,4a8,8,0,0,0-.676,15.972A3.648,3.648,0,0,1,10.811,18.111ZM7.5,12A1.5,1.5,0,1,1,9,10.5,1.5,1.5,0,0,1,7.5,12Zm9,0A1.5,1.5,0,1,1,18,10.5,1.5,1.5,0,0,1,16.5,12ZM12,9a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,9Z",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/Paint.41b8d0ab7347976cb2d92885a31f8def.svg";
export { ForwardRef as ReactComponent };